import React from "react";

import { WorkTypesConfirmModals } from "../components/WorkTypesConfirmModals";
import { WorkTypesListHeader } from "../components/WorkTypesListHeader";
import { WorkTypesTable } from "../components/WorkTypesTable";
import { useWorkTypesListController } from "../hooks/useWorkTypesListController";
import { WorkTypeListStatus } from "../model/workTypesList.types";

type Props = {
  initialStatus?: WorkTypeListStatus;
};

export const WorkTypesPage: React.FC<Props> = ({ initialStatus = "all" }) => {
  const { headerProps, tableProps, modalProps } =
    useWorkTypesListController(initialStatus);

  return (
    <>
      <div className={"mb-[120px] py-6"}>
        <WorkTypesListHeader {...headerProps} />
        <WorkTypesTable {...tableProps} />
      </div>
      <WorkTypesConfirmModals {...modalProps} />
    </>
  );
};
